import { render } from "./Parceiro.vue?vue&type=template&id=537e0574&scoped=true"
import script from "./Parceiro.vue?vue&type=script&lang=js"
export * from "./Parceiro.vue?vue&type=script&lang=js"

import "./Parceiro.vue?vue&type=style&index=0&id=537e0574&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537e0574"]])

export default __exports__